import { ReactRenderer } from '@tiptap/react';
import { type SuggestionOptions } from '@tiptap/suggestion';
import tippy, { type Instance } from 'tippy.js';
import { type IReference } from '../../../references/IReference.ts';
import {
  ComputeExpressionReferenceList,
  type ComputeExpressionReferenceListRef,
  type IComputeExpressionReferenceListProps,
} from './ComputeExpressionReferenceList.tsx';

export const computeExpressionReferenceSuggestion = (
  references: IReference[],
): Omit<SuggestionOptions, 'editor'> => ({
  items: ({ query }) => {
    const q = query.toLowerCase();
    return references.filter(
      item =>
        item.label?.toLowerCase().includes(q) ||
        item.code?.toLowerCase().includes(q),
    );
  },

  render: () => {
    let component: ReactRenderer<
      ComputeExpressionReferenceListRef,
      IComputeExpressionReferenceListProps
    >;
    let popup: Instance[];

    return {
      onStart: props => {
        component = new ReactRenderer(ComputeExpressionReferenceList, {
          props,
          editor: props.editor,
        });

        if (!props.clientRect) {
          return;
        }

        popup = tippy('body', {
          getReferenceClientRect: props.clientRect as any,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start',
          // Contenuto: il popup si apre nel punto del testo in cui si scrive
          maxWidth: 400,
        });
      },

      onUpdate(props) {
        component.updateProps(props);

        if (!props.clientRect) {
          return;
        }

        popup[0].setProps({
          getReferenceClientRect: props.clientRect as any,
        });
      },

      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          popup[0].hide();

          return true;
        }

        return component.ref?.onKeyDown(props) ?? false;
      },

      onExit() {
        popup[0].destroy();
        component.destroy();
      },
    };
  },
});
